<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import branch_officesAPI from "../../../services/branch_offices/branch_officesAPI";
import CompanyAPI from "../../../services/company/companyAPI";
import CompanySSOAPI from "../../../services/sso/company/companySSO.API";
import Swal from "sweetalert2";
import { required } from 'vuelidate/lib/validators'

/**
 * Form elements component
 */
export default {
  page: {
    title: "Sedes",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "Sedes",
      items: [{
        text: 'Gestión empresa',
        href: '/forms/listado-empresa',
      },
      {
        text: 'editar de sede',
        active: true,
      },
      
      ],

      submitted: false,
      branch_officesData: {
        name: null,
        phone: null,
        address: null,
        company_id: this.$route.params.id,
        company_name: null,
      },
    };
  },

   validations: {
    branch_officesData: {
      name: {
        required,
      },
      phone: {
        required,
      },
      address: {
        required,
      },
      company_id: {
        required,
      },
      company_name: {
        required,
      },

    },
  },

  methods: {
    getBranchOffice() {
      branch_officesAPI
        .getBranchOffice(this.$route.params.id)
        .then((response) => {
          this.branch_officesData = {
            name: response.name,
            address: response.address,
            phone: response.phone,
            company_id: response.company_id,
            company_name: null,
          };
          CompanyAPI.getCompany(response.company_id)
            .then((res) => {
              CompanySSOAPI.getCompany(res.uuid)
                .then((r) => {
                  console.log(r);
                  this.branch_officesData.company_name = r.social_reason;
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        });
    },
    update() {

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
       
       if (this.$v.$invalid) {
        return;
      } else {
        
      branch_officesAPI
        .updateBranchOffice(this.$route.params.id, {
          name: this.branch_officesData.name,
          phone: this.branch_officesData.phone,
          address: this.branch_officesData.address,
          company_id: this.branch_officesData.company_id,
        })
        .then((response) => {
          Swal.fire({
                title: "Sede actualizada con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
          this.$router.go(-1);
          console.log(response);
        });
    }
     },
     
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getBranchOffice();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h4 class="header-title mb-4">Editar sede</h4>
              </div>

              <div class="col-6 text-right">
                <div @click="goBack" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>
 
            <div class="row">
              <div class="col-3"></div>
              <div class="col-md-6">
                <div class="card-body">
                  <form class="form-horizontal form-group" role="form" @submit.prevent="update">

                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Nombre de la empresa"
                      label-for="inputEmail3">
                      <b-form-input type="text" id="name" placeholder="" v-model="branch_officesData.company_name"
                        disabled></b-form-input>
                    </b-form-group>


                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Nombre de la sede" label-for="name">
                      <b-form-input type="text"  maxlength="45" id="name" placeholder="Ingrese el nombre de la sede"
                        v-model="branch_officesData.name" :class="{
                          'is-invalid':
                            $v.branch_officesData.name.$error && submitted,
                        }" ></b-form-input>
                        <div v-if="submitted && $v.branch_officesData.name.$error">
                        <small v-if="!$v.branch_officesData.name.required" class="text-danger">
                          <b>El nombre es requerido</b>
                        </small>
                      </div>
                    </b-form-group>

                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Teléfono" label-for="phone">
                      <b-form-input maxlength="10"  type="tel"  autocomplete="off"
                        onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" id="phone"
                        placeholder="Ingrese el número telefónico de la sede" v-model="branch_officesData.phone" :class="{
                          'is-invalid':
                            $v.branch_officesData.phone.$error && submitted,
                        }">
                      </b-form-input>
                      <div v-if="submitted && $v.branch_officesData.phone.$error">
                        <small v-if="!$v.branch_officesData.name.required" class="text-danger">
                          <b>El número telefónico es requerido</b>
                        </small>
                      </div>
                    </b-form-group>


                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Dirección" label-for="address">
                      <b-form-input maxlength="45"  type="text" id="address" placeholder="Ingrese la dirección de la sede"
                        v-model="branch_officesData.address" :class="{
                          'is-invalid':
                            $v.branch_officesData.address.$error && submitted,
                        }"></b-form-input>
                        <div v-if="submitted && $v.branch_officesData.address.$error">
                        <small v-if="!$v.branch_officesData.address.required" class="text-danger">
                          <b>La dirección de la sede es requerida</b>
                        </small>
                      </div>
                    </b-form-group>

                    <div class="form-group text-right m-b-0">
                      <button class="btn btn-primary" type="submit">
                        Guardar
                      </button>
                      <button type="button" @click="goBack" class="btn btn-secondary m-l-5 ml-1">
                        Cancelar
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
